import { GridWidgetService } from '../grid-widget.services';
import { SystemService } from 'common/services/core-services/system.service';
import { DataModel, MetaModel, WidgetModel } from 'common/models/utility-models/base-model';
import { Injectable } from '@angular/core';
import { NotificationModel } from 'common/models/page-models/notification/notification-data.model';
import { NotificationGridMetaModel } from 'common/models/page-models/notification/notification-grid-meta.model';
import { NotificationListingModel } from 'common/models/page-models/notification/notification-grid.model';
import { NotificationGridDataService } from 'common/services/data-services/admin/notification/notification-grid-data.service';
import { SmMetaModel } from 'common/models/utility-models/meta-model';

@Injectable({
    providedIn: 'root'
})
export class NotificationGridWidgetService extends GridWidgetService<NotificationModel, NotificationListingModel> {
    constructor(protected override ds: NotificationGridDataService, protected systemService: SystemService) {
        super(ds);
    }

    getMetaModel(): MetaModel {
        const meta = new NotificationGridMetaModel().getMetaModel();
        return meta;
    }
    
}

